/*
 * DRIVLY-UI React Components
 * @license MIT
 */
function e(e){"function"==typeof queueMicrotask?queueMicrotask(e):Promise.resolve().then(e).catch((e=>setTimeout((()=>{throw e}))))}export{e as microTask};
//# sourceMappingURL=micro-task.js.map
